import {
  init,
  setContext,
  setUser,
  thirdPartyErrorFilterIntegration,
} from "@sentry/browser"

const config = window.MinuteDock?.sentry

if (config) {
  init({
    dsn: config.dsn,
    release: config.release,
    environment: config.environment,
    enabled: config.enabled,
    integrations: [
      // Matches the webpack applicationKey and legacy metadata marker. Sentry uses
      // it to distinguish first-party stack frames from third-party browser code.
      thirdPartyErrorFilterIntegration({
        filterKeys: ["minutedock-frontend"],
        behaviour: "apply-tag-if-exclusively-contains-third-party-frames",
      }),
    ],
    denyUrls: [
      // Intercom messenger iframe bundles (FRONTEND-67, FRONTEND-3P, FRONTEND-8W)
      /frame-modern\.[a-f0-9]+\.js$/,
      /js\.intercomcdn\.com\/(?:app~tooltips|frame|vendor|vendors~sentry~app)\.[a-f0-9]+\.js$/,
    ],
    // Browser-side fetch aborts from Turbo navigations (user navigating away
    // mid-request, network drops, extensions). Not actionable, one per browser.
    // (FRONTEND-1Z, FRONTEND-98, FRONTEND-99)
    ignoreErrors: [
      "ResizeObserver loop completed with undelivered notifications.",
      "AbortError: The user aborted a request.",
      "AbortError: Fetch is aborted",
      "AbortError: signal is aborted without reason",
      "AbortError: The operation was aborted.",
      // Third-party analytics transport timeout; not a MinuteDock request failure.
      "AbortError: PostHog request timed out after 3000ms",
      "Script error.",
      "TypeError: Failed to fetch",
      "TypeError: NetworkError when attempting to fetch resource",
      "TypeError: Load failed",
      "TypeError: cancelled",
    ],
  })

  if (config.user) {
    setUser(config.user)
  }

  if (config.account) {
    setContext("account", config.account)
  }
}
